import React, { Component } from 'react';
import { Container, Col, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RowItem } from '../layout/RowItem';
import AuthFunctions from '../services/AuthService';

import '../layout/site.css';

export class Admin extends Component {
    static displayName = Admin.name;

    constructor(props) {
        super(props);

        this.state = {
            admin: false,
            checked: false // helps prevent �flash� / weird blankness
        };
    }

    async componentDidMount() {
        await this.checkAuthenticatedAndAdmin();
    }

    async checkAuthenticatedAndAdmin() {
        const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
            return;
        }

        const isAdmin = await AuthFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
            return;
        }

        this.setState({ admin: true, checked: true });
    }

    render() {
        // Optional: if you want literally nothing until auth/admin is checked
        // (prevents any �blank-ish� partial render)
        if (!this.state.checked && !this.state.admin) {
            return null;
        }

        return (
            <div>
                <Container className='container-main'>
                    <RowItem>
                        <Col>
                            <h3>Admin</h3>
                        </Col>
                    </RowItem>

                    {this.state.admin && (
                        <RowItem>
                            <ul className='ul-link'>
                                <NavLink tag={Link} to='/admin/roles'>Roles</NavLink>
                                <NavLink tag={Link} to='/admin/users'>Users</NavLink>
                            </ul>
                        </RowItem>
                    )}
                </Container>
            </div>
        );
    }
}